module.exports = __webpack_public_path__ + "kidcoe-logo.png?008cddb84ef8cc068b378de78987161d";